export default __webpack_public_path__ + "static/media/face2.f14e6948.jpg";